module.exports = __webpack_public_path__ + "static/posterVideo-470a1298607b2da21911682e331a6b28.png";